import $ from 'jquery';
import { checkTotalAddToCart } from "../product-add-to-cart";

let editIcon = $( '.specification-value svg' );
editIcon.on( 'click', function () {
	$( '.customer-number' ).focus();
} );

export class IntercompanyOrders {
	constructor() {

		this.$available_stock_locations = $( '.available-stock__location' );

		this.setEvents();
		this.updateView();
	}

	updateView() {
		let total_amount = 0;
		this.$available_stock_locations.each( ( index, location ) => {
			$( location ).removeClass( 'inactive' );

			let $input = $( location ).find( 'input[type=number]' );
			let value = ( $input.val() ) ? parseInt( $input.val() ) : 0;

			if ( value === 0 ) {
				$( location ).addClass( 'inactive' );
			}

			total_amount = total_amount + value;
		} )
		$( '.total_amount' ).html( total_amount );
	}

	setEvents() {
		this.$available_stock_locations.each( ( index, location ) => {
			let $input_wrapper = $( location ).find( '.available-stock--Input' ),
				$input = $input_wrapper.find( 'input[type=number]' ),
				$minus_trigger = $input_wrapper.find( '.minus' ),
				$plus_trigger = $input_wrapper.find( '.plus' ),
				backorderData = $input_wrapper.attr( 'data-backorder' ),
				$backorder = false,
				backorderBranch = true;

			if ( $( location )[ 0 ].classList.contains( 'inactive' ) ) {
				backorderBranch = false;
			}

			if ( backorderData === 'true' ) {
				$backorder = true;
			} else {
				$backorder = false;
			}

			let value = $input.val(),
				min_value = parseInt( $input.attr( 'min' ) ),
				max_value = parseInt( $input.attr( 'max' ) );

			$minus_trigger.on( 'click', () => {
				value = $input.val();

				if ( value > min_value ) {
					value--;
					$input.val( value ).trigger( 'change' );
				}

				checkTotalAddToCart();
			} )

			$plus_trigger.on( 'click', () => {
				value = $input.val();

				if ( value < max_value || $backorder === true ) {
					value++;
					if ( backorderBranch === true ) {
						setBackOrderValue( value, max_value, $input_wrapper );
					}

					$input.val( value ).trigger( 'change' );
					checkTotalAddToCart();
				}
			} )

			$input.on( 'change blur load ready', () => {
				if ( backorderBranch === true ) {
					setBackOrderValue( $input.val(), max_value, $input_wrapper );
				}

				this.updateView();
			} )

			$input.on( 'keyup', function () {
				let v = parseInt( $( this ).val() );
				let min = parseInt( $( this ).attr( 'min' ) );
				let max = parseInt( $( this ).attr( 'max' ) );

				if ( $backorder === true ) {
					$( this ).removeAttr( 'max' );
					if ( backorderBranch === true ) {
						setBackOrderValue( v, max_value, $input_wrapper );
					}
				}

				if ( v < min ) {
					$( this ).val( min );
				} else if ( v > max && $backorder === false ) {
					$( this ).val( max );
				}
			} )
		} )
	}
}

new IntercompanyOrders();


let valueElement = $( '.cart-amount' );

function incrementValue( e ) {
	valueElement.val( Math.max( parseInt( valueElement.val() ) + e.data.increment, 1 ) );
	return true;
}

function setBackOrderValue( value, max_value ) {
	let $backorder_div = $( '.backorder' ),
		$spacer_div = $( '.spacer' ),
		$backorder_amount = $( '.backorder__value' ),
		$backorder_value = 0;

	if ( value > max_value ) {
		$backorder_div.addClass( 'visible' );
		$spacer_div.addClass( 'visible' );

		$backorder_value = value - max_value;
	} else {
		$backorder_div.removeClass( 'visible' );
		$spacer_div.removeClass( 'visible' );
	}

	$backorder_amount.html( $backorder_value );
}

$( document ).on( 'click', '#plus', { increment: 1 }, incrementValue );
$( document ).on( 'click', '#minus', { increment: -1 }, incrementValue );

$( document ).on( 'submit', '.product-detail__add-to-cart-form', function () {
	const $btn = $( this ).find( '.product-detail__actions__add-to-cart-button button' );

	$btn.html( $btn.data( 'loading' ) );
	$btn.prop( 'disabled', true );

	return true;
} );